module.exports = __webpack_public_path__ + "static/media/LandingPageLogo3.9aaae3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/LandingPageLogo3.png
// module id = 392
// module chunks = 0